<template lang="pug">
  .container.grid-xl.py-2
    .panel
      .panel-header
        .h4.text-primary Editar Modelo de Documento
        steps.pt-2(:steps="steps" :step-style="{ fontSize: '.55rem' }")
        .divider
      .panel-body.mb-2
        .empty(v-if="loading")
          .loading-container
            .loading.loading-lg
          p.empty-title.h5 Carregando dados
          p.empty-subtitle Aguarde um momento, estamos buscando as informações para você
        router-view(v-else)
</template>

<script>
import api from '@/api/sistema/docModelos'
import { LocalStorageFacade } from 'paliari-js-utils'
import DocModelo from '@/models/DocModelo'

export default {
  props: ['id'],
  data() {
    return {
      loading: false,
      steps: [
        { routeName: 'sistema.docModelos.edit.info', title: 'Informações' },
        {
          routeName: 'sistema.docModelos.edit.parametros',
          title: 'Parâmetros',
        },
        {
          routeName: 'sistema.docModelos.edit.calculo',
          title: 'Cálculo',
        },
        {
          routeName: 'sistema.docModelos.edit.reincidencia',
          title: 'Reincidência',
        },
        {
          routeName: 'sistema.docModelos.edit.assuntos',
          title: 'Assuntos',
        },
        {
          routeName: 'sistema.docModelos.edit.irregularidades',
          title: 'Irregularidades',
        },
        {
          routeName: 'sistema.docModelos.edit.integracao',
          title: 'Integração',
        },
        {
          routeName: 'sistema.docModelos.edit.textos',
          title: 'Textos',
        },
        {
          routeName: 'sistema.docModelos.edit.confirmar',
          title: 'Confirmar',
        },
      ],
    }
  },
  async created() {
    try {
      this.loading = true
      const resource = await api.one(this.id)
      LocalStorageFacade.setItem('docModelo', new DocModelo(resource))
    } catch (e) {
      this.$toaster.error('Falha ao buscar o modelo')
    } finally {
      this.loading = false
    }
  },
  destroyed() {
    LocalStorageFacade.removeItem('docModelo')
  },
}
</script>
